module.exports = __webpack_public_path__ + "img/expand_less.742ba7a9.svg";